import { postResultDenomination } from '../api/postResultDenomination';

const setPostResultDenomination = (params, setOpenModal) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postResultDenomination(params);

            if (data.status === 'success') {
                setOpenModal(data.data);
                alert(JSON.stringify(data.data))
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostResultDenomination
}